var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#008080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 22.5V21.1667C19.3337 20.4594 19.0527 19.7811 18.5526 19.281C18.0525 18.781 17.3742 18.5 16.667 18.5H11.3337C10.6264 18.5 9.94814 18.781 9.44804 19.281C8.94794 19.7811 8.66699 20.4594 8.66699 21.1667V22.5M23.3337 22.5C23.3337 20.5 23.3337 19.5 21.3337 18.5M18.667 10.5867C19.2406 10.7335 19.749 11.0671 20.1121 11.5349C20.4752 12.0026 20.6722 12.5779 20.6722 13.17C20.6722 13.7621 20.4752 14.3374 20.1121 14.8051C19.749 15.2729 19.2406 15.6065 18.667 15.7533M16.667 13.1667C16.667 14.6394 15.4731 15.8333 14.0003 15.8333C12.5276 15.8333 11.3337 14.6394 11.3337 13.1667C11.3337 11.6939 12.5276 10.5 14.0003 10.5C15.4731 10.5 16.667 11.6939 16.667 13.1667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7e89b5684cde90bf71075c68a8333768.svg";
export { ForwardRef as ReactComponent };